import '../../styles/button.scss';

import { FC } from 'react';
import { Link as RouterLink, LinkProps, To } from 'react-router-dom';

interface AdditionalLinkProps {
  to?: To;
  showVisitedState?: boolean;
  variant?: 'default' | 'inverse';
}
type GovUKLinkProps = Omit<LinkProps, 'to'> & AdditionalLinkProps;

const Link: FC<GovUKLinkProps> = ({
  children,
  to = '#',
  className = '',
  showVisitedState = false,
  variant = 'default',
  ...props
}: GovUKLinkProps) => {
  const hasGovukButtonClass = /(^|\s)govuk-button(\s|$)/.test(className);
  const linkClassName = `govuk-link${variant === 'inverse' ? ' govuk-link--inverse' : ''}${showVisitedState || variant !== 'default' ? '' : ' govuk-link--no-visited-state'} ${className}`;

  return (
    <RouterLink to={to} className={hasGovukButtonClass ? className : linkClassName} {...props}>
      {children}
    </RouterLink>
  );
};

export default Link;

export function StartButton({ children, ...props }: GovUKLinkProps) {
  return (
    <Link
      role="button"
      draggable="false"
      className="govuk-button govuk-button--start"
      data-module="govuk-button"
      {...props}
    >
      {children}
      <svg
        className="govuk-button__start-icon"
        xmlns="https://www.w3.org/2000/svg"
        width="17.5"
        height="19"
        viewBox="0 0 33 40"
        aria-hidden="true"
        focusable="false"
      >
        <path fill="currentColor" d="M0 0h13l20 20-20 20H0l20-20z" />
      </svg>
    </Link>
  );
}
